var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('details-base',{staticClass:"mb20",attrs:{"details":_vm.details}}),_c('feed-information',{staticClass:"mb20",attrs:{"detailsA":_vm.details}}),_c('input-information',{staticClass:"mb20",attrs:{"details":_vm.details}}),_c('estimated-results',{ref:"EstimatedResults",staticClass:"mb20",attrs:{"isAdd":_vm.isAdd,"details":_vm.details}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }